<template>
  <div class="list-container">
    <div class="bread-crumbs"><router-link to="/">主页</router-link><router-link :to="$route.fullPath">'{{ keyword
        }}'的搜索结果</router-link>
    </div>
    <div class="list-title desktop">‘{{ keyword }}’的搜索结果({{ total }})</div>

    <div v-if="list && list.length" class="list-section">


      <div class="list-wrapper">
        <div class="filter-items">
          <ListFilter scope="search" :filterOpts="filterOpts" />
        </div>

        <div class="list-items">
          <!-- 列表头部 -->
          <div class="list-header">
            <!-- <div class="list-title">“{{ keyword }}”的搜索结果({{ total }})</div> -->
            <div class="list-header-extra">
              <!-- 移动端：点击打开左侧筛选抽屉 -->
              <div class="list-filter-mini" @click="openFilterDrawer">筛选</div>
              <div class="list-sort">
                <el-select class="sort-items" v-model="sort" placeholder="排序方式" @change="optsChange('sort')">
                  <el-option value="default" label="默认"></el-option>
                  <el-option value="new" label="最新发售"></el-option>
                  <el-option value="sales" label="销量"></el-option>
                  <el-option value="price:desc" label="价格↓"></el-option>
                  <el-option value="price:asc" label="价格↑"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <!-- 已选过滤条件 -->
          <div class="list-filter-opts-selected" v-if="showSelectedFilterItem">
            <div class="list-filter-flag">筛选</div>
            <!-- 已选过滤条件：分类 -->
            <template v-if="getCheckedList('category').length">
              <div class="filter-item">
                <span class="filter-item-name">分类: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('category')" :key="i">
                  {{ item | findFilterItem(filterOpts['category']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('category', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：性别 -->
            <template v-if="getCheckedList('genders').length">
              <div class="filter-item">
                <span class="filter-item-name">性别: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('genders')" :key="i">
                  {{ item | findFilterItem(filterOpts['genders']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('genders', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：尺寸 -->
            <template v-if="getCheckedList('sizes').length">
              <div class="filter-item">
                <span class="filter-item-name">尺码: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('sizes')" :key="i">
                  {{ item | findFilterItem(filterOpts['sizes']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('sizes', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：颜色 -->
            <template v-if="getCheckedList('colors').length">
              <div class="filter-item">
                <span class="filter-item-name">颜色: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('colors')" :key="i">
                  {{ item }}
                  <a class="filter-item-remove" @click="removeFilterItem('colors', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：系列 -->
            <template v-if="getCheckedList('series').length">
              <div class="filter-item">
                <span class="filter-item-name">系列: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('series')" :key="i">
                  {{ item | findFilterItem(filterOpts['series']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('series', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：品牌 -->
            <template v-if="getCheckedList('brand').length">
              <div class="filter-item">
                <span class="filter-item-name">品牌: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('brand')" :key="i">
                  {{ item | findFilterItem(filterOpts['brand']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('brand', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：衣长 -->
            <template v-if="getCheckedList('clothingLength').length">
              <div class="filter-item">
                <span class="filter-item-name">衣长: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('clothingLength')" :key="i">
                  {{ item | findFilterItem(filterOpts['clothingLength']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('clothingLength', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：袖长 -->
            <template v-if="getCheckedList('sleeveLength').length">
              <div class="filter-item">
                <span class="filter-item-name">袖长: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('sleeveLength')" :key="i">
                  {{ item | findFilterItem(filterOpts['sleeveLength']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('sleeveLength', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <!-- 已选过滤条件：尺寸 -->
            <template v-if="getCheckedList('measurements').length">
              <div class="filter-item">
                <span class="filter-item-name">尺寸: </span>
                <span class="filter-item-value" v-for="(item, i) in getCheckedList('measurements')" :key="i">
                  {{ item | findFilterItem(filterOpts['measurements']) }}
                  <a class="filter-item-remove" @click="removeFilterItem('measurements', item)">
                    <i class="iconfont">&#xe657;</i>
                  </a>
                </span>
              </div>
            </template>
            <div class="clear-all" @click="clearAll">清除</div>
          </div>
          <!-- 列表主体 -->
          <div class="list-context">
            <ul class="list-result">
              <li v-for="(item, index) in list" :key="index">
                <ListItem :data="item" scope="list" :isGwMdEnablePoint="isGwMdEnablePoint" :hasBrand="hasBrand" @itemview="showItemDialog" />
              </li>
            </ul>
            <div class="paging">
              <Pagination :total="total" :limit="limit" :current="currPage" @change="changePage" />
              <div class="list-footer-size">
                <label htmlFor="footer-limit-size" class="list-footer-size-hits">查看:&nbsp;</label>
                <el-select class="list-footer-size-items" v-model="limit" placeholder="每页大小"
                  @change="optsChange('limit')">
                  <el-option :value="24" label="24"></el-option>
                  <el-option :value="48" label="48"></el-option>
                  <el-option :value="96" label="96"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="list && !list.length" class="list-nomore">
      <div class="nomore-box">
        <i class="iconfont-ot-website">&#xe69c;</i>
        <div class="tips">您要查找的商品未找到：{{ keyword }}</div>
      </div>
      <div class="recommend-box">
        <Recommend />
      </div>
    </div>
    <!-- 快速购买 - 商品弹窗 -->
    <div class="dialog view-item-dialog" v-if="viewItem && viewItem.id && viewItem.color">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <div class="dialog-title">商品信息</div>
          <button type="button" class="dialog-close" @click="hideItemDialog">
            <span class="close-icon"></span>
          </button>
        </div>
        <div class="dialog-body">
          <ViewItemInfo scope="list" :id="viewItem.id" :isGwMdEnablePoint="isGwMdEnablePoint" :color="viewItem.color"
            :styleNumber="viewItem.style_number" confirmText="加入购物车" @notify="setNotify" @confirm="addToCart"
            @checkout="toBuyNow" />
        </div>
      </div>
    </div>
    <!-- 快速购买 - 加购成功弹窗（共用组件，无遮罩、吸在当前 header 下方） -->
    <CartSuccessDialog :info="cartInfo" :headerHeight="headerHeight" @close="closeCartDialog(0)"
      @checkout="toCheckout" @cart="toCart" :isGwMdEnablePoint="isGwMdEnablePoint"/>
    <!-- 快速购买 - 通知弹窗 -->
    <div class="dialog notify-dialog" v-if="notifyItem">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <div class="dialog-title">到货通知</div>
          <button class="dialog-close" @click="hideNotifyDialog">
            <span class="close-icon"></span>
          </button>
        </div>
        <div class="dialog-body">
          <ItemNotify :source="notifyItem" @confirm="sendNotify" />
        </div>
      </div>
    </div>
    <!-- 登录弹窗 -->
    <div class="dialog login-dialog" v-if="showLogin">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <i class="iconfont dialog-close" @click="hideLoginDialog">&#xe612;</i>
        </div>
        <div class="dialog-body">
          <Login :returnUrl="returnUrl" />
        </div>
      </div>
    </div>
    <!-- 移动端筛选抽屉 -->
    <MobileFilterDrawer :filterOpts="filterOpts" :visible="filterDrawerVisible" :total="total"
      @close="filterDrawerVisible = false" />
  </div>
</template>

<script>
// @ is an alias to /src
import types from '@/store/types';
import api from '@/utils/api';
import ListFilter from '@/components/ListFilter.vue';
import MobileFilterDrawer from '@/components/MobileFilterDrawer.vue';
import ListItem from '@/components/ListItem.vue';
import Recommend from '@/components/Recommend.vue';
import ViewItemInfo from '@/components/ViewItemInfo.vue';
import ItemNotify from '@/components/ItemNotify.vue';
import Login from '@/components/Login.vue';
import CartSuccessDialog from '@/components/CartSuccessDialog.vue';
import { Message } from 'element-ui';
import utils from "@/utils";
// List/Search 共用的筛选页逻辑（query 解析/where 构建/已选管理/抽屉开关）
import filterPageMixin from '@/mixins/filterPage';
import Pagination from '@/components/Pagination.vue';

export default {
  name: 'Search',
  components: { ListFilter, MobileFilterDrawer, Pagination, ListItem, Recommend, ViewItemInfo, ItemNotify, Login, CartSuccessDialog },
  mixins: [filterPageMixin],
  data() {
    return {
      keyword: '',
      newKW: '',
      list: null, // 商品列表
      // 筛选/分页等共享状态在 filterPage mixin 中声明
      viewItem: null,
      cartInfo: null, // 加购成功弹层数据
      headerHeight: 0, // 加购成功弹层吸顶偏移（弹出时实时测量）
      notifyItem: null,
      showLogin: false,
      returnUrl: '',
      pendingBuyNow: null // 未登录直购暂存: 登录成功后自动重放
    }
  },
  created() { },
  mounted() {
    this.initWithArgs();
  },
  methods: {
    initWithArgs() {
      // 筛选/排序/分页解析在共享 mixin 的 parseRouteQuery 中
      this.parseRouteQuery(this.$route.query);
      let { q: kw } = this.$route.query;
      kw ? (this.keyword = kw) : (this.keyword = '');
      this.loadSource();
    },
    // 更改页码: 写入路由 query, 由 $route watch 统一触发重新加载; 第 1 页不落参数
    changePage({ currPage: page }) {
      let query = Object.assign({}, this.$route.query);
      page > 1 ? (query.page = page) : delete query.page;
      this.$router.push({
        path: this.$route.path,
        query: query
      });
    },
    loadSource() {
      if (utils.regEmoji.test(this.keyword)) {
        Message({
          message: '关键词中包含Emoji字符',
          type: "warning"
        });
        return;
      }
      let newArgs = this.buildWhereArgs();
      newArgs.keyword = this.keyword;
      api[types.SEARCH](newArgs).then(res => {
        if (res?.code == 1) {
          let { list, total } = res.data;
          this.list = list || [];
          this.total = total;
          this.$nextTick(() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
          });
        } else {
          console.warn(res);
        }
      }).catch(err => {
        console.warn(err);
      });
      // 拉取筛选项（mock 调试分支在共享 mixin 中，联调后删除）
      this.loadFilterOptions(newArgs, types.SEARCH_LAYER);
    },
    // 显示商品信息弹窗
    showItemDialog(attr) {
      console.log(attr)
      this.viewItem = attr;
    },
    // 关闭商品信息弹窗
    hideItemDialog() {
      this.viewItem = null;
    },
    // 显示到货通知
    setNotify(info) {
      if (!info || !info.id) return console.warn('缺少商品信息'), false;
      this.viewItem = null;
      this.notifyItem = info;
    },
    // 关闭到货通知
    hideNotifyDialog() {
      this.notifyItem = null;
    },
    // 加入购物车（与 Detail/List 同链路：按登录态走会员/游客加购接口）
    addToCart(args) {
      let { info, color, size, quantity } = args;
      const params = {
        product: String(info.id),
        product_option: [
          {
            option_id: color?.attribute_id,
            option_value: color?.id,
          },
          {
            option_id: size?.attribute_id,
            option_value: size?.option_id,
          },
        ],
        qty: quantity,
        sku: String(size.sku || size.id),
        is_presale: Number(color?.is_pre_sales) === 1,
      }
      if (this.isLogin) {
        api[types.ADD_TO_CUSTOMER_CART](params)
          .then((res) => {
            if (res?.code == 1) {
              this.showCartDialog(res);
              this.addToCartEnd(args);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        api[types.ADD_TO_CART_GUEST](params)
          .then((res) => {
            if (res?.code == 1) {
              this.showCartDialog(res);
              this.addToCartEnd(args);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    // 加购成功：关商品弹窗（避免盖住成功弹层）、按当前 header 实际高度吸顶、写入弹层数据
    showCartDialog(res) {
      this.viewItem = null;
      this.headerHeight = document.querySelector('.ot-header')?.offsetHeight || 0;
      this.cartInfo = res.data.info;
      this.cartInfo.info.cover = this.cartInfo?.info?.images[0];
    },
    // 加购成功：刷新购物车角标、自动关弹层、GA 埋点
    addToCartEnd(args) {
      let { info, color, quantity } = args;
      this.$store.dispatch(types.GET_CART_INFO);
      this.closeCartDialog(3000);
      this.gaTrack4AddToCart({
        id: info.style_number,
        name: info.name,
        price: info.price,
        quantity,
        category: info.category?.name,
        variant: color?.name,
      });
    },
    // GA add_to_cart 埋点
    gaTrack4AddToCart(info) {
      if (info?.id && window.gtag) {
        window.gtag("event", "add_to_cart", {
          send_to: process.env?.VUE_APP_GA4,
          currency: "CNY",
          value: Number(info.price),
          items: [
            {
              item_id: info.id,
              item_name: info.name,
              item_brand: "Onitsuka Tiger",
              item_category: info.category,
              item_variant: info.variant,
              price: Number(info.price),
              quantity: Number(info.quantity),
              currency: "CNY",
            },
          ],
        });
      }
    },
    // 关闭加购成功弹层（closeCartDialog(0) 立即关闭）
    closeCartDialog(time) {
      setTimeout(() => {
        this.cartInfo = null;
      }, time);
    },
    // 快速购买弹窗"立即购买"：登录走直购结算，未登录先登录、成功后自动重放直购
    toBuyNow(args) {
      let { size, quantity, skuStatus } = args;
      // 根据 SKU 状态决定购物袋类型：预售→is_presale，普通→is_buy_now
      const cartType = utils.getCartType(skuStatus === 'PreSales' ? 'presale' : 'buy_now');
      const params = { sku: String(size.sku || size.id), qty: quantity, cartType };
      if (this.isLogin) {
        this.execBuyNow(params);
      } else {
        // 未登录：暂存直购参数并弹登录框（returnUrl 回当前页），登录成功后由 isLogin watcher 自动重放
        this.viewItem = null; // 关商品弹窗再弹登录框
        this.pendingBuyNow = params;
        this.returnUrl = encodeURIComponent(this.$route.fullPath);
        this.showLoginDialog();
      }
    },
    // 执行直购：BUY_NOW 成功缓存后带 cartType 进结算页
    async execBuyNow(params) {
      try {
        const res = await api[types.BUY_NOW](params);
        if (res?.code == 1) {
          const confirmCacheKey = await this.$store.dispatch('requestCache/setRequestCache', { params, value: res });
          // URL 带 sku/qty/cartType: 刷新结算页时缓存丢失可重调 BUY_NOW 重建结算数据
          this.$router.push({ path: `/checkout?cartType=${params.cartType}&sku=${params.sku}&qty=${params.qty}&confirmCacheKey=${confirmCacheKey}` });
        } else {
          console.warn(res);
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 加购成功 -> 立即结算
    toCheckout() {
      if (this.isLogin) {
        const { size, quantity } = this.cartInfo?.info || {}
        const params = { sku: String(size.sku || size.id), qty: quantity, cartType: 'is_buy_now' }
        api[types.BUY_NOW](params).then(async res => {
          if (res?.code == 1) {
            const confirmCacheKey = await this.$store.dispatch('requestCache/setRequestCache', { params, value: res });
            this.$router.push({ path: `/checkout?cartType=${params.cartType}&sku=${params.sku}&qty=${params.qty}&confirmCacheKey=${confirmCacheKey}` });
          } else {
            console.warn(res);
          }
        })
      } else {
        this.showLoginDialog();
      }
    },
    // 加购成功 -> 去购物车
    toCart() {
      this.$router.push({ path: "/cart" });
    },
    showLoginDialog() {
      this.showLogin = true;
    },
    hideLoginDialog() {
      this.returnUrl = '';
      this.showLogin = false;
    },
    // 到货通知设置成功
    sendNotify() {
      this.hideNotifyDialog();
    },
    // 重新搜索
    searchKW() {
      let kw = this.newKW;
      if (!kw) {
        return;
      }
      this.newKW = '';
      this.$router.push({
        name: 'Search',
        query: { q: kw }
      });
    }
  },
  computed: {
    // 列表中是否存在品牌项(供 ListItem 占位对齐)
    hasBrand() {
      return this.list?.some(i => i?.brand?.name) || false;
    },
    // 是否允许显示原价（受 gw_md_enable 配置控制）
    isGwMdEnablePoint() {
      return utils.isGwMdEnable(this.$store.state.commonConfig['gw_md_enable'], 'search')
    },
    isLogin() {
      return this.$store.state.isLogin;
    }
  },
  watch: {
    // 登录成功后关闭登录弹框（Login 组件无事件回调，以登录态变化感知）
    isLogin(val) {
      if (val && this.showLogin) {
        this.hideLoginDialog();
      }
      // 登录成功且有暂存直购参数：自动重放 buyNow 流程
      if (val && this.pendingBuyNow) {
        const params = this.pendingBuyNow;
        this.pendingBuyNow = null;
        this.execBuyNow(params);
      }
    },
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.initWithArgs();
    }
  }
}
</script>

<style lang="scss" scoped>
.list-container {
  box-sizing: border-box;
  margin: auto;
  width: calc(100% - 20px);
  max-width: 1200px;
  padding: 0 .625rem;

  .bread-crumbs {
    width: 100%;
    font-size: calc(.6875rem * 1.6);
    top: 0;
    left: 50%;
    z-index: 1;
    line-height: 1em;
    // line-height: 22px;
    // height: 22px;
    padding: .5em 0;
    text-align: left;
    margin-bottom: 25px;

    a {
      font-size: calc(.6875rem * 1.6);
      color: #4B4F54;
      margin-right: 5px;

      &:hover {
        font-weight: 400;
        color: #999;
        text-decoration: underline;
      }

      &::after {
        color: #ccc;
        content: "/";
        margin-left: .4em;
        display: inline-block;
      }

      &:last-child::after {
        content: "";
      }
    }
  }

  .list-title {
    color: var(---, #212322);
    text-align: left;
    font-family: Matter;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    padding: 10px 0 20px 0;

    &.desktop {
      border-bottom: 1px solid #000;
    }
  }

  .list-section {
    max-width: 1200px;
    margin: 0 auto;
    margin-bottom: 100px;

    .list-wrapper {
      &::after {
        content: "";
        display: table;
        clear: both;
      }

      .filter-items {
        width: 230px;
        float: left;
      }

      .list-items {
        box-sizing: border-box;
        width: calc(100% - 230px - 50px);
        float: left;
        margin-left: 50px;

        .list-header {
          box-sizing: border-box;
          width: calc(100% - 20px);
          max-width: 1200px;
          border-bottom: 1px solid #b4b5b4;
          padding: 16px 0 10px;
          position: relative;
          margin: 0 auto calc(1.3125rem * 1.6);
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-end;

          .list-title {
            font-weight: 400;
            font-size: calc(2rem * 1.6);
            line-height: normal;
            line-height: 1em;
            color: #000;
            cursor: pointer;
            display: block;
            float: left;
            margin: 0;
            margin-right: auto;
            padding: 0;
          }

          .list-header-extra {
            display: flex;

            .list-filter-mini {
              display: none;
              height: 40px;
              line-height: 40px;
              padding: 0 0 0 10px;
              text-align: left;
            }

            select {
              width: 100%;
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
            }

            .list-limit {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              padding-right: 10px;

              label {
                font-size: calc(.875rem * 1.6);
                letter-spacing: .025em;
                display: block;
                color: #000;
                margin-right: 5px;
                white-space: nowrap;
              }

              & ::v-deep .el-select {
                width: 65px;

                .el-input .el-input__inner {
                  border: 2px solid #b4b5b4;
                }
              }
            }

            .list-sort {
              display: flex;
              justify-content: flex-start;
              align-items: center;

              & ::v-deep .el-select {
                width: 110px;

                .el-input .el-input__inner {
                  border: 2px solid #b4b5b4;
                }
              }
            }
          }

          .list-filter-opts {
            display: none;
          }
        }

        .list-filter-opts-selected {
          box-sizing: border-box;
          margin-bottom: 10px;
          width: calc(100% - 20px);
          max-width: 1200px;
          margin: 0 auto calc(1.3125rem * 1.6);
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -ms-flex-wrap: wrap;
          -webkit-flex-wrap: wrap;
          flex-wrap: wrap;
          -ms-flex-align: center;
          -webkit-align-items: center;
          align-items: center;

          .list-filter-flag {
            line-height: calc(1.875rem * 1.6);
            font-size: calc(.875rem * 1.6);
            color: #000;
            margin-right: 20px;
            text-transform: capitalize;
          }

          .filter-item {
            color: #000;
            background: #efefef;
            border: 1px solid #b4b5b4;
            margin: 5px 20px 5px 0;
            padding: 0 10px;
            line-height: calc(1.725rem * 1.6);
            font-size: calc(.875rem * 1.6);

            .filter-item-value {
              margin-left: 8px;

              .filter-item-remove {
                margin-left: 5px;
                cursor: pointer;
                color: #000;

                &:hover {
                  text-decoration: none;
                }

                .iconfont {
                  font-size: 12px;
                }
              }
            }
          }

          .clear-all {
            color: #666;
            font-size: calc(.75rem * 1.6);
            letter-spacing: .025em;
            cursor: pointer;
            text-decoration: underline;

            &:hover {
              font-weight: 400;
              color: #999;
              text-decoration: underline;
            }
          }
        }

        .list-context {
          margin-bottom: 10px;

          .list-result {
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -ms-flex-wrap: wrap;
            -webkit-flex-wrap: wrap;
            flex-wrap: wrap;
            margin: 0;
            padding: 0;

            li {
              border-right: 1px solid #b4b5b4;
              border-bottom: 1px solid #b4b5b4;
              border-top: none;
              margin-top: 0;
              padding: 0;
              width: 33.33333%;
              position: relative;
              box-sizing: border-box;

              &:nth-child(3n+3) {
                border-right: none;
              }
            }
          }

          .paging {
            margin: 40px auto 0;
            position: relative;
            height: 60px;

            .list-footer-size {
              display: flex;
              align-items: center;
              position: absolute;
              top: 50%;
              right: 10px;
              transform: translateY(-50%);

              .list-footer-size-hits {
                font-weight: 400;
                font-size: calc(.875rem * 1.6);
                letter-spacing: .025em;
                color: #000;
                white-space: nowrap;
                margin-right: 4px;
              }

              & ::v-deep .el-select {
                width: 65px;

                .el-input .el-input__inner {
                  border: 2px solid #b4b5b4;
                }
              }
            }
          }
        }
      }
    }
  }

  .recommend-box {
    padding-top: 35px;
  }

  .list-nomore {
    padding-top: 20px;


    .nomore-box {
      background: #FDF0D5;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      width: 100%;
      padding: 10px 20px 10px 10px;
      margin-bottom: 50px;
      box-sizing: border-box;

      .iconfont-ot-website {
        font-size: 24px;
        color: #C07600;
      }

      .tips {
        color: #6F4400;
        text-align: center;
        font-family: "Noto Sans CJK SC";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: uppercase;
        padding-top: 2px;
      }

      .nomore-hits {
        text-align: left;
        padding: 1px 0 20px;

        h1 {
          color: #000;
          line-height: calc(1.25rem * 1.6);
          font-size: calc(1.25rem * 1.6);
          font-weight: 700;
          margin: 0;
        }

        h2 {
          color: var(---, #212322);
          text-align: left;
          font-family: Matter;
          font-size: 32px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          text-transform: uppercase;
        }
      }

      .search-help {
        ul {
          padding: 16px;

          li {
            text-align: left;
            list-style: square outside none;
            line-height: calc(1.5rem * 1.6);
            font-size: calc(.875rem * 1.6);
            font-weight: 400;
            color: #000;
          }
        }
      }

      .search-hits {
        width: 100%;
        margin: 0;
        font-weight: 400;
        border-top: 1px solid hsla(120, 1%, 71%, .25);
        padding: 1.25rem 0;
        text-align: left;

        a {
          font-weight: 400;
          color: #333;
        }
      }
    }
  }

  .dialog {
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: url(../assets/imgs/ui-overlay-shadow.png) repeat scroll 50% 50% #000;
      opacity: 0.3;
      z-index: 1010;
    }

    .dialog-container {
      box-sizing: border-box;
      position: fixed;
      z-index: 1011;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #FFF;
      min-width: 300px;
      max-width: 95%;
      min-height: 200px;
      border-radius: 4px;

      .dialog-header {
        position: relative;
        text-align: left;

        .dialog-title {
          border-bottom: 1px solid #b4b5b4;
          font-weight: 400;
          font-size: calc(1.375rem * 1.6);
          color: #000;
          text-transform: uppercase;
          padding: calc(1.25rem * 1.6) calc(1.25rem * 1.6) calc(0.5rem * 1.6) 0;
          margin: 0 calc(1.25rem * 1.6);
          width: calc(100% - 40px);
          box-sizing: border-box;
        }

        .dialog-close {
          width: 32px;
          height: 32px;
          position: absolute;
          top: -15px;
          right: -15px;
          padding: 0;
          border: none;
          border-radius: 0;
          margin: 0;
          background-color: transparent;
          font-size: 0;
          cursor: pointer;

          .close-icon {
            background-image: url(../assets/imgs/icons/onitsukatiger-close.svg);
            background-position: 0 0;
            background-repeat: no-repeat;
            height: 32px;
            width: 32px;
            margin: 0;
            padding: 0;
            display: block;
            text-indent: -99999px;
            overflow: hidden;
          }
        }
      }

      .dialog-body {
        box-sizing: border-box;
        display: flex;
        padding: 20px;
      }
    }

    &.view-item-dialog {
      .dialog-container {
        width: 920px;
        max-width: 95%;

        .dialog-header {
          .dialog-title {
            display: none;
          }
        }
      }
    }

    &.notify-dialog {
      .dialog-container {
        width: 834px;
        background-color: #efefef;

        .dialog-header {
          .dialog-title {
            border-bottom: 1px solid #b4b5b4;
            font-weight: 400;
            font-size: calc(1.375rem * 1.6);
            color: #000;
            text-transform: uppercase;
            padding: calc(1.25rem * 1.6) calc(1.25rem * 1.6) calc(0.5rem * 1.6) 0;
            margin: 0 calc(1.25rem * 1.6);
            width: calc(100% - 40px);
            box-sizing: border-box;
          }
        }

        .dialog-body {
          padding: 20px;
        }
      }
    }

    &.login-dialog {
      .dialog-container {
        width: 470px;
        height: 600px;

        .dialog-header {
          height: 40px;

          .dialog-close {
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 32px;
            color: #999999;
            cursor: pointer;
          }
        }

        .dialog-body {
          & ::v-deep .login-component {
            width: 100%;

            .title {
              text-align: center;
            }

            .el-form {
              width: 80%;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  .list-container {

    .bread-crumbs {
      width: 100%;
      font-size: 12px;
      top: 0;
      left: 50%;
      z-index: 1;
      line-height: 1em;
      // line-height: 22px;
      // height: 22px;
      padding: 20px 0 0;
      text-align: left;
      margin-bottom: 25px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      a {
        font-size: 12px;
        color: #4B4F54;
        margin-right: 5px;

        &:hover {
          font-weight: 400;
          color: #999;
          text-decoration: underline;
        }

        &::after {
          color: #ccc;
          content: "/";
          margin-left: .4em;
          display: inline-block;
        }

        &:last-child::after {
          content: "";
        }
      }
    }

    .list-title {
      color: var(---, #212322);
      text-align: center;
      font-family: Matter;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: uppercase;
      padding: 0;

      &.desktop {
        border-bottom: none;
      }
    }

    .list-section {
      .list-wrapper {
        .filter-items {
          display: none;
        }

        .list-items {
          width: 100%;
          margin: 0;

          .list-header {
            border-bottom: 0;
            margin: 0 auto;
            flex-direction: column;
            justify-content: flex-start;
            padding-top: 25px;

            .list-title {
              margin-bottom: 28px;
            }

            .list-header-extra {
              .list-filter-mini {
                overflow: hidden;
                display: block;
                padding-right: 31px;
                box-sizing: border-box;
                border: 1px solid #b4b5b4;
                border-radius: 2px;
                background: #efefef url(../assets/imgs/icons/plus.svg) no-repeat scroll;
                background-position: right 10px center;
                position: relative;
                clear: left;
                cursor: pointer;
                float: left;
                width: calc(50% - 5px);

                &.active {
                  background: #efefef url(../assets/imgs/icons/minus.svg) no-repeat scroll;
                  background-position: right 10px center;
                }
              }

              .list-limit {
                display: none;
              }

              .list-sort {
                width: calc(50% - 5px);
                height: 40px;
                margin: 0;
                margin-left: calc(.625rem * 1.6);
                overflow: hidden;
                display: block;
                // padding-right: 31px;
                box-sizing: border-box;
                border: 1px solid #b4b5b4;
                border-radius: 2px;
                background: #efefef url(../assets/imgs/icons/plus.svg) no-repeat scroll;
                background-position: right 10px center;
                position: relative;

                & ::v-deep .el-select {
                  width: 100%;

                  .el-input {
                    .el-input__inner {
                      border: 0;
                      background: transparent;
                    }

                    .el-input__suffix {
                      display: none;
                    }
                  }
                }
              }
            }

            .list-filter-opts {
              display: block !important;
              margin-top: 5px;
              background: #efefef;
              border: 1px solid #b4b5b4;
              float: left;
              display: none;
              padding: calc(.6875rem * 1.6);
              width: calc(100% - 24px);

              .list-filter-opts-close {
                font-weight: 400;
                font-size: .8125rem;
                padding: 15px 0 5px;
                text-align: center;
                color: #333;
                cursor: pointer;
              }
            }
          }

          .list-context {
            .list-result {
              li {
                width: 50%;
                border-bottom: 1px solid #b4b5b4;

                &:nth-child(3n+3) {
                  border-right: 1px solid #b4b5b4;
                }

                &:nth-child(2n+2) {
                  border-right: none;
                }
              }
            }
          }
        }
      }
    }

    .list-nomore {
      padding-top: 25px;

      .nomore-box {
        background: #FDF0D5;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 4px;
        width: 100%;
        padding: 10px 20px 10px 10px;
        box-sizing: border-box;

        .iconfont-ot-website {
          font-size: 24px;
          color: #C07600;
        }

        .tips {
          color: #6F4400;
          text-align: center;
          font-family: "Noto Sans CJK SC";
          font-size: 12px;
          text-align: left;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          text-transform: uppercase;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .list-container {
    .list-section {
      margin-bottom: 80px;

      .list-wrapper {
        .list-items {
          .list-context {
            .paging {
              .pagination-wrapper {
                .pagination-hits {
                  text-align: left;
                  margin-bottom: 20px;
                }
              }

              .list-footer-size {
                top: 14%;
              }
            }
          }
        }
      }
    }

    .dialog {
      &.view-item-dialog {
        .dialog-container {
          position: absolute;
          top: 100px;
          transform: translate(-50%, 0);
        }
      }

      &.notify-dialog {
        .dialog-container {
          position: absolute;
          top: 100px;
          transform: translate(-50%, 0);
          background: #FFF;
        }
      }
    }
  }
}

@media only screen and (max-width: 480px) {
  .list-container {
    .dialog {
      &.view-item-dialog {
        .dialog-container {
          top: 50px;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-header {
            .dialog-title {
              display: block;
            }

            .dialog-close {
              top: 10px;
              right: 10px;

              .close-icon {
                background-image: url(../assets/imgs/icons/onitsukatiger-close2.svg);
                background-position: center center;
              }
            }
          }
        }
      }

      &.notify-dialog {
        .dialog-container {
          top: 50px;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-header {
            .dialog-close {
              top: 10px;
              right: 10px;

              .close-icon {
                background-image: url(../assets/imgs/icons/onitsukatiger-close2.svg);
                background-position: center center;
              }
            }
          }
        }
      }

      &.login-dialog {
        .dialog-container {
          position: fixed;
          top: 0;
          left: 0;
          transform: none;
          // transform: translate(-50%, 0);
          background: #FFF;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-body ::v-deep .login-component {
            .el-form {
              width: calc(100% - 40px);
            }
          }
        }
      }
    }
  }
}
</style>
<style scoped>
.list-container .dialog.view-item-dialog .dialog-container {
  top: max(50%, 370px);
}

.list-container .dialog.notify-dialog .dialog-container {
  top: max(50%, 355px);
}
</style>
